import { render } from "./ProdutoAutomatizadoEdit.vue?vue&type=template&id=a92639ce&scoped=true"
import script from "./ProdutoAutomatizadoEdit.vue?vue&type=script&lang=js"
export * from "./ProdutoAutomatizadoEdit.vue?vue&type=script&lang=js"

import "./ProdutoAutomatizadoEdit.vue?vue&type=style&index=0&id=a92639ce&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a92639ce"

export default script